import React from "react";
import FactCheckIcon from "./fact_check_black_24dp.svg?react";

export default function CheckinIcon(props) {
	const width = props.width ? props.width : "24px";
	const height = props.height ? props.height : "24px";
	return <FactCheckIcon width={width} height={height} />;
}
